import { Barcode } from "@/components/Barcode";
import type { DealItem } from "@/types/deal";

interface DealPriceTagProps {
  item: DealItem;
  price: string;
}

export const DealPriceTag = ({ item, price }: DealPriceTagProps) => {
  return (
    <div
      className="dymo-tag relative mx-auto overflow-hidden rounded border border-border font-mono print:mx-0 print:border-none"
      style={{ width: "2in", height: "0.75in" }}
    >
      <div
        className="flex h-full w-full flex-row-reverse items-center gap-[0.06in]"
        style={{ padding: "0.05in 0.07in", boxSizing: "border-box" }}
      >
        {/* LEFT: Price */}
        <div
          className="flex shrink-0 flex-col items-center justify-center"
          style={{ width: "0.7in" }}
        >
          <p className="text-[18px] font-extrabold leading-none text-primary print:text-black">
            ${price}
          </p>
        </div>

        {/* RIGHT: Brand + Name + Barcode */}
        <div className="flex h-full min-w-0 flex-1 flex-col justify-between py-[0.02in]">
          <p className="w-full text-right text-[7px] font-extrabold uppercase leading-none tracking-wide text-foreground print:text-black">
            Lynx to the Past
          </p>

          <p className="line-clamp-2 w-full text-right text-[9px] font-bold leading-[1.05] text-foreground print:text-black">
            {item.name}
          </p>

          {item.upc ? (
            <div className="flex w-full items-end overflow-hidden">
              <Barcode
                value={item.upc}
                height={14}
                width={1}
                fontSize={0}
                displayValue={false}
                className="h-auto w-full max-w-full"
              />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default DealPriceTag;
